/**
 * chatOverlay.js
 * Pure canvas helper for drawing in-world chat speech bubbles.
 * Extracted from Nightclub.js for modularity.
 */

/**
 * Draw a role-styled speech bubble with text at (x, y).
 * @param {CanvasRenderingContext2D} ctx
 * @param {number} x - horizontal center
 * @param {number} y - vertical center of the bubble
 * @param {string} text - message text (truncated to ~18 chars)
 * @param {string} role - 'owner' | 'admin' | 'overseer' | other
 * @param {boolean} mobile - mobile layout flag (smaller dimensions)
 */
export const drawChatBubble = (ctx, x, y, text, role, mobile) => {
  const fontSize = mobile ? 12 : 14;
  ctx.font = `${fontSize}px sans-serif`;
  const metrics = ctx.measureText(text);
  const padding = mobile ? 8 : 10;
  const maxWidth = mobile ? 120 : 180;
  const width = Math.min(metrics.width + padding * 2, maxWidth);
  const height = mobile ? 26 : 32;

  // Role-based styling
  if (role === 'owner') {
    const gradient = ctx.createLinearGradient(x - width / 2, y, x + width / 2, y);
    gradient.addColorStop(0, '#DC2626');
    gradient.addColorStop(1, '#7C3AED');
    ctx.fillStyle = gradient;
    ctx.shadowColor = '#DC2626';
    ctx.shadowBlur = 15;
  } else if (role === 'admin' || role === 'overseer') {
    ctx.fillStyle = 'rgba(147, 51, 234, 0.95)';
    ctx.strokeStyle = '#9333EA';
    ctx.shadowColor = '#9333EA';
    ctx.shadowBlur = 10;
  } else {
    ctx.fillStyle = 'rgba(255, 255, 255, 0.95)';
    ctx.shadowBlur = 0;
  }

  // Bubble body
  ctx.beginPath();
  ctx.roundRect(x - width / 2, y - height / 2, width, height, 10);
  ctx.fill();

  if (role === 'admin' || role === 'overseer') {
    ctx.lineWidth = 2;
    ctx.stroke();
  }

  ctx.shadowBlur = 0;

  // Pointer tail
  ctx.beginPath();
  ctx.moveTo(x - 6, y + height / 2);
  ctx.lineTo(x, y + height / 2 + 10);
  ctx.lineTo(x + 6, y + height / 2);
  ctx.closePath();
  ctx.fill();

  // Text
  ctx.fillStyle =
    role === 'owner' || role === 'admin' || role === 'overseer' ? '#FFF' : '#000';
  ctx.textAlign = 'center';
  ctx.font = `bold ${fontSize}px sans-serif`;
  const displayText = text.length > 18 ? `${text.substring(0, 18)}...` : text;
  ctx.fillText(displayText, x, y + 5);
};
